module.exports = {"TXTWCL_Your_voucher_amount":{"id":"TXTWCL_Your_voucher_amount","defaultMessage":"Сумма ваучера","track":"Your voucher amount"}}